import React from 'react';
import clsx from 'clsx';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Button from '@/elements/Button/Button.component';
import { AnchorProps } from '@/elements/Button/Button.interface'; // Import AnchorProps from the interface file
import Card from '@/components/Card/Card.component';
import { IProps } from './FixedContentBlock.interface';
import './FixedContentBlock.styles.css';

export const FixedContentBlock: React.FC<IProps> = ({
    title,
    cta,
    cards,
    columns = 3,
    className,
    ...blockWrapperProps
}) => {

    return (
        <BlockWrapper
            className={clsx('fixedContentBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                <ContentColumn>
                    {(title || cta) && (
                        <div className="fixedContentBlock__header">
                            {title && <Heading level={2} html={title} className='fixedContentBlock__heading' />}
                            {cta && <Button {...cta} className='fixedContentBlock__cta' />}
                        </div>
                    )}
                    {cards && cards.length > 0 && (
                        <div
                            className={clsx('fixedContentBlock__cards', `fixedContentBlock__cards--${columns}`)}
                        >
                            {cards.map((card, idx) => (
                                <Card key={`card-${idx}`} {...card} className='fixedContentBlock__card' cta={{...(card?.cta || {}), variant: 'secondary', color: 'primary'}} />
                            ))}
                        </div>
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};
